// mostrarToast('Empresa creada correctamente', { tono: 'exito' });
//
// Notificación efímera de esquina inferior derecha. Se expone como función
// (no como elemento que el consumidor arma a mano) porque su ciclo de vida
// es autocontenido: aparece, se apila si hay otra activa, y se autodestruye —
// no hay estado que el llamador necesite gestionar.

const TONOS = {
  exito: {
    color: 'var(--pf-color-exito, #15803d)',
    fondo: 'var(--pf-color-exito-fondo, #dcfce7)',
    borde: 'var(--pf-color-exito-borde, #bbf7d0)',
  },
  peligro: {
    color: 'var(--pf-color-peligro, #b91c1c)',
    fondo: 'var(--pf-color-peligro-fondo, #fee2e2)',
    borde: 'var(--pf-color-peligro-borde, #fecaca)',
  },
  info: {
    color: 'var(--pf-color-info, #1d4ed8)',
    fondo: 'var(--pf-color-info-fondo, #dbeafe)',
    borde: 'var(--pf-color-info-borde, #bfdbfe)',
  },
};

class ToastContenedor extends HTMLElement {
  connectedCallback() {
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          position: fixed;
          bottom: 20px;
          right: 20px;
          display: flex;
          flex-direction: column;
          gap: 8px;
          z-index: 9999;
          font-family: var(--pf-fuente, 'Inter', system-ui, sans-serif);
        }
        .toast {
          min-width: 280px;
          max-width: 400px;
          padding: 12px 16px;
          border-radius: 6px;
          border: 1px solid transparent;
          font-size: 0.875rem;
          font-weight: 500;
          line-height: 1.4;
          animation: entrar 0.15s ease-out;
          box-shadow: 0 2px 8px rgba(11, 19, 43, 0.06);
        }
        @keyframes entrar {
          from { transform: translateY(8px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      </style>
      <div class="pila" role="status" aria-live="polite"></div>
    `;
  }

  agregar(mensaje, tono) {
    const { color, fondo, borde } = TONOS[tono] ?? TONOS.info;
    const el = document.createElement('div');
    el.className = 'toast';
    el.style.color = color;
    el.style.background = fondo;
    el.style.borderColor = borde;
    el.textContent = mensaje;
    this.shadowRoot.querySelector('.pila').appendChild(el);
    return el;
  }
}

customElements.define('pf-toast-contenedor', ToastContenedor);

/** @type {ToastContenedor | null} */
let _contenedor = null;

function obtenerContenedor() {
  if (!_contenedor) {
    _contenedor = document.createElement('pf-toast-contenedor');
    document.body.appendChild(_contenedor);
  }
  return _contenedor;
}

/**
 * Muestra una notificación efímera.
 *
 * @param {string} mensaje
 * @param {{ tono?: 'exito' | 'peligro' | 'info', duracionMs?: number }} [opciones]
 */
export function mostrarToast(mensaje, opciones = {}) {
  const { tono = 'info', duracionMs = 4000 } = opciones;
  const contenedor = obtenerContenedor();
  const el = contenedor.agregar(mensaje, tono);
  setTimeout(() => el.remove(), duracionMs);
}
